export const userDataSelector = state => state.userData;

export const userSelector = state => state.userData?.user;

export const isUserAuthorized = state => state.userData?.authorized;